/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IErrorMessage,
  IPermission,
  defaultRoleValue,
  IRole,
} from "@advapacs/common";

const initialState = {
  loading: false,
  errorMessage: null as IErrorMessage | null,
  entities: [] as Array<IRole>,
  entity: defaultRoleValue,
  totalItems: 0,
  permissions: [] as Array<IPermission>,
  isUpdated: false,
  entityList: [] as Array<IRole>,
};

const roleSlice = createSlice({
  name: "roleSlice",
  initialState,
  reducers: {
    startSearchRoles(state) {
      state.loading = true;
      state.isUpdated = false;
    },
    searchRolesSuccess(state, action: PayloadAction<Array<IRole>>) {
      state.entities = action.payload;
      state.loading = false;
    },
    searchRolesFail(state) {
      state.loading = false;
      state.entities = [];
    },
    startCreateEUnityRole(state) {
      state.loading = true;
      state.isUpdated = false;
    },
    createEUnityRoleSuccess(state) {
      state.loading = false;
      state.isUpdated = true;
    },
    createEUnityRoleFail(state, action: PayloadAction<IErrorMessage | null>) {
      state.loading = false;
      state.errorMessage = action.payload;
      state.isUpdated = false;
    },
    startUpdateEUnityRole(state) {
      state.loading = true;
      state.isUpdated = false;
    },
    updateEUnityRoleSuccess(state) {
      state.loading = false;
      state.isUpdated = true;
    },
    updateEUnityRoleFail(state, action: PayloadAction<IErrorMessage | null>) {
      state.loading = false;
      state.errorMessage = action.payload;
      state.isUpdated = false;
    },
    getRoleSuccess(state, action: PayloadAction<IRole>) {
      state.entity = action.payload;
    },
    getRoleFail(state) {
      state.entity = defaultRoleValue;
    },
    startCreateRole(state) {
      state.loading = true;
      state.isUpdated = false;
    },
    createRoleSuccess(state) {
      state.loading = false;
      state.isUpdated = true;
    },
    createRoleFail(state, action: PayloadAction<IErrorMessage | null>) {
      state.loading = false;
      state.errorMessage = action.payload;
      state.isUpdated = false;
    },
    startUpdateRole(state) {
      state.loading = true;
      state.isUpdated = false;
    },
    updateRoleSuccess(state) {
      state.loading = false;
      state.isUpdated = true;
    },
    updateRoleFail(state, action: PayloadAction<IErrorMessage | null>) {
      state.loading = false;
      state.errorMessage = action.payload;
      state.isUpdated = false;
    },
    clearErrorMessage(state) {
      state.errorMessage = null;
    },
    getPermissionsSuccess(state, action: PayloadAction<Array<IPermission>>) {
      state.permissions = action.payload;
    },
    getPermissionFail(state) {
      state.permissions = [];
    },
    clearData: () => initialState,
    getRoleList(state, action: PayloadAction<Array<IRole>>) {
      state.entityList = action.payload;
      state.loading = false;
    },
  },
});

export const RoleAction = roleSlice.actions;
export default roleSlice.reducer;
